<div class="user-card {{ userCardClass }}">
  <div class="user-card-name-img-container">
    <ng-container *ngIf="card.cardName === 'VISA'; else otherCards">
      <img src="img/payment/visa.png" class="user-card-name user-card-name-img">
    </ng-container>
    <ng-template #otherCards>
      <ng-container *ngIf="card.cardName === 'MASTERCARD'; else otherMaestro">
        <img src="img/payment/mastercard.png" class="user-card-name user-card-name-img">
      </ng-container>
    </ng-template>
    <ng-template #otherMaestro>
      <ng-container *ngIf="card.cardName === 'MAESTRO'; else otherDiners">
        <img src="img/payment/maestro.png" class="user-card-name user-card-name-img">
      </ng-container>
    </ng-template>
    <ng-template #otherDiners>
      <ng-container *ngIf="card.cardName === 'DINERS'; else defaultText">
        <img src="img/payment/diners.png" class="user-card-name user-card-name-img">
      </ng-container>
    </ng-template>
  </div>

  <ng-template #defaultText>
    <p class="user-card-name">{{ card.cardName }}</p>
  </ng-template>

  <ng-container *ngIf="card.isDefault">
    <span class="primary-card">{{ "MY_CARDS.PRIMARY_CARD" | translate }}</span>
  </ng-container>
  
  <p class="user-card-number">{{ card.cardNumber }}</p>
  <p class="user-card-expiration-date">{{ card.expirationDate }}</p>
</div>